/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Full_NameInputs */

const en_legal_full_name = /** @type {(inputs: Legal_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal Full Name`)
};

const es_legal_full_name = /** @type {(inputs: Legal_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre completo legal`)
};

const fr_legal_full_name = /** @type {(inputs: Legal_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom complet légal`)
};

const de_legal_full_name = /** @type {(inputs: Legal_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständiger rechtlicher Name`)
};

const ja_legal_full_name = /** @type {(inputs: Legal_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`法的な氏名 (フルネーム)`)
};

const zh_legal_full_name = /** @type {(inputs: Legal_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`法定全名`)
};

const ar_legal_full_name = /** @type {(inputs: Legal_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الاسم القانوني الكامل`)
};

const id_legal_full_name = /** @type {(inputs: Legal_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama Lengkap Resmi`)
};

const it_legal_full_name = /** @type {(inputs: Legal_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome e Cognome Legale`)
};

const ru_legal_full_name = /** @type {(inputs: Legal_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полное юридическое имя`)
};

const pt_legal_full_name = /** @type {(inputs: Legal_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome Completo Legal`)
};

const ko_legal_full_name = /** @type {(inputs: Legal_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`법적 성명(Full Name)`)
};

/**
* | output |
* | --- |
* | "Legal Full Name" |
*
* @param {Legal_Full_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const legal_full_name = /** @type {((inputs?: Legal_Full_NameInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Full_NameInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legal_full_name(inputs)
	if (locale === "es") return es_legal_full_name(inputs)
	if (locale === "fr") return fr_legal_full_name(inputs)
	if (locale === "de") return de_legal_full_name(inputs)
	if (locale === "ja") return ja_legal_full_name(inputs)
	if (locale === "zh") return zh_legal_full_name(inputs)
	if (locale === "ar") return ar_legal_full_name(inputs)
	if (locale === "id") return id_legal_full_name(inputs)
	if (locale === "it") return it_legal_full_name(inputs)
	if (locale === "ru") return ru_legal_full_name(inputs)
	if (locale === "pt") return pt_legal_full_name(inputs)
	return ko_legal_full_name(inputs)
});